import randomstring from "randomstring";
import GeneratorView from "../../components/GeneratorView";
import GeneratorOptions from "./GeneratorOptions";

const generate = ({ count, characters, length, casing }) => {
  return [...new Array(count)].map(() =>
    randomstring.generate({
      length,
      charset: characters,
      capitalization: casing === "mixed" ? null : casing,
    })
  );
};

const Index = ({ strings, toolStrings }) => (
  <GeneratorView
    toolStrings={toolStrings}
    strings={strings}
    onGenerate={generate}
    optionsView={GeneratorOptions}
    options={{
      length: 10,
      characters: "alphanumeric",
      casing: "mixed",
      count: 20,
      strings,
    }}
  />
);

export default Index;
